import React, { useState } from 'react';
import Slider from '@mui/material/Slider';

function PokedexFilterStatSlider({
  label,
  initialValue,
  globalRangeOnChange,
}: {
  label: string
  initialValue: number[],
  globalRangeOnChange: (newValue: number[]) => void,
}) {
  const [value, setValue] = useState<number[]>(initialValue);
  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number[]);
    globalRangeOnChange(newValue as number[]);
  };
  return (
    <div className="my-4 flex justify-center text-center">
      <div className="w-10/12">
        {label}
        <Slider
          min={1}
          max={255}
          value={value}
          onChange={handleChange}
          valueLabelDisplay="auto"
          sx={{
            '& .MuiSlider-track': {
              border: 'none',
            },
            '& .MuiSlider-thumb': {
              width: 18,
              height: 18,
              backgroundColor: '#fff',
              '&:hover, &.Mui-focusVisible, &.Mui-active': {
                boxShadow: 'none',
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default PokedexFilterStatSlider;
